export default __webpack_public_path__ + "static/media/gallery-14-1.ae77f2df.webp";